export const bankList = {
  isSuccessful: false,
  isLoading: false,
  error: {},
  bankArray: {},
};

export const userAccountInfo = {
  isSuccessful: false,
  isLoading: false,
  acctInfo: {},
};

export const coinValue = {
  isSuccessful: false,
  isLoading: false,
  price: {},
};

export const createTrans = {
  isSuccessful: false,
  isLoading: false,
  payload: {},
}

export const coins = {
  isSuccessful: false,
  payload: {},
}


// DASHBOARD
export const loginState = {
  isSuccessful: false,
  isLoading: false,
  payload: {},
  error: false,
};
export const registerState = {
  isSuccessful: false,
  isLoading: false,
  payload: {},
};

export const forgotPasswordState = {
  isSuccessful: false,
  isLoading: false,
  payload: {},
  error: false,
};

export const changePassword = {
  isSuccessful: false,
  isLoading: false,
  payload: {},
  error: false,
};

export const authAllCoins = {
  isSuccessful: false,
  isLoading: false,
  payload: {},
}

export const allTransactions = {
  isSuccessful: false,
  isLoading: false,
  payload: {},
}

export const eachCoin = {
  isSuccessful: false,
  isLoading: false,
  error: true,
  payload: {},
}